/**
 * Sets or updates the browser tab favicon link.
 * Pass null/empty to restore the default /favicon.ico.
 */
export const applyBrowserFavicon = (href) => {
  if (typeof document === 'undefined') return

  const nextHref = String(href || '').trim() || '/favicon.ico'
  let link = document.querySelector("link[rel~='icon']")
  if (!link) {
    link = document.createElement('link')
    link.rel = 'icon'
    document.head.appendChild(link)
  }

  const lower = nextHref.toLowerCase()
  if (lower.endsWith('.png')) link.type = 'image/png'
  else if (lower.endsWith('.svg')) link.type = 'image/svg+xml'
  else if (lower.endsWith('.webp')) link.type = 'image/webp'
  else if (lower.endsWith('.gif')) link.type = 'image/gif'
  else if (lower.endsWith('.ico')) link.type = 'image/x-icon'
  else link.removeAttribute('type')

  if (link.href !== nextHref) {
    link.href = nextHref
  }
}
